// src/api/roleApi.js
import apiClient from "./axios";

const roleApi = {
  // GET all (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = "", is_active) => {
    const response = await apiClient.get("/roles/", {
      params: { page, page_size: pageSize, search,is_active },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post("/roles/", data);
    return response.data;
  },

  // UPDATE
  update: async (id, data) => {
    const response = await apiClient.put(`/roles/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/roles/${id}/`);
    return id;
  },

  // DUPLICATE — copies name/level/permissions into a brand-new role
  duplicate: async (id, data) => {
    const response = await apiClient.post(`/roles/${id}/duplicate/`, data);
    return response.data;
  },
};

export default roleApi;
